export default {
  'app.org.title': 'Organisasi',
  'app.org.column.id': 'ID Organisasi',
  'app.org.column.name': 'Nama Organisasi',
  'app.org.column.timezone': 'Zona Waktu',
  'app.org.column.website': 'URL',
  'app.org.column.isCreator': 'Pembuat',
  'app.org.column.createTime': 'Waktu Pembuatan',
  'app.org.column.operate': 'Operasi',
  'app.org.column.operate.enter': 'Masuk',
  'app.org.column.operate.edit': 'Edit',
  'app.org.column.operate.delete': 'Hapus',
  'app.org.column.operate.placeholder': 'silakan masukkan nama organisasi/ ID organisasi',
  'app.org.create': 'Buat organisasi',
  'app.org.create.submit': 'Buat organisasi',
  'app.org.bind.tip': 'Buat organisasi',
  'app.org.create.tip': 'Sudah diorganisir?',
  'app.org.create.tip.bind': 'untuk mengikat',
  'app.org.success.tip': 'Kembali Ke Konsol',
  'app.org.bind': 'Ikat organisasi',
  'app.org.bind.submit': 'Selesaikan Ikat',
  'app.org.create.create': 'Buat',
  'app.org.create.cancel': 'Batal',
  'app.org.create.save': 'Simpan',
  'app.org.create.profile': 'Profil Organisasi',
  'app.org.create.name.placeholder': 'Masukkan nama organisasi',
  'app.org.create.website.placeholder': 'Masukkan URL (domain tingkat atas)',
  'app.org.create.timezone': 'Zona Waktu',
  'app.org.create.timezone.tip': '( Setelah dipilih, tidak dapat diubah )',
  'app.org.create.currency': 'Mata Uang',
  'app.org.create.usd': 'USD',
  'app.org.create.success': 'Berhasil dibuat',
  'app.org.edit.success': 'Edit berhasil',
  'app.org.rule.blank': 'Bidang ini tidak boleh kosong',
  'app.org.rule.char': 'Karakter ilegal tidak diizinkan dalam nama karakter',
  'app.org.rule.name.exists': 'Nama organisasi sudah ada',
  'app.org.rule.url.exists': 'URL sudah ada',
  'app.org.rule.url.start': 'Silakan masukkan URL yang dimulai dengan www',
  'app.org.delete.title': 'Hapus Organisasi',
  'app.org.delete.content':
    'Peringatan! Menghapus organisasi Anda tidak dapat dibatalkan. Ini akan secara permanen menghapus data dan informasi seperti pengguna, bisnis, saldo, tagihan, pesanan, dan kepentingan organisasi ini, dan semua layanan terkait akan dihentikan.',
  'app.org.delete.warn': 'Ketika ada tambahan yang harus dibayar, akun Anda tidak dapat dihapus!',
  'app.org.delete.cancel': 'Batal',
  'app.org.delete.next': 'Selanjutnya',
  'app.org.delete.delete': 'Hapus',
  'app.org.delete.confirm': 'Konfirmasi penghapusan',
  'app.org.delete.confirm.content':
    'Sebelum penghapusan akun Anda berlaku, kami akan memverifikasi akun Anda sebagai berikut. Silakan temukan kode verifikasi di email.',
  'app.org.delete.confirm.send': 'Kirim kode verifikasi',
  'app.org.delete.confirm.send.resend': 'Kirim ulang kode verifikasi',
  'app.org.delete.confirm.resend': 'Kirim ulang',
  'app.org.delete.confirm.rule': 'Silakan masukkan verifikasi yang benar',
  'app.org.delete.success': 'Hapus berhasil',
  'app.org.delete.balance': 'Organisasi ini memiliki saldo dan tidak dapat dihapus.',
};
